// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"205":"DokumenIndex","727":"KwarranIndex","887":"BannerIndex","894":"KontakIndex"}[chunkId] + "." + {"205":"7db5da6d","727":"1a71ac89","887":"5c0694e5","894":"cfa6e119"}[chunkId] + ".css";
};